import React from 'react';

import { toDDHHMMSS } from '../../../../Util/Util';

const progressBar = (props) => {
    let classOrden = 'normal';
    let classDespacho = 'normal';
    let classFactura = 'normal';
    let classRuta = 'normal';

    if(props.tiempos.Orden && props.tiempos.Orden !== 0) {
        classOrden = props.tiempos.EstadoOrden;
    }

    if(props.tiempos.Despacho && props.tiempos.Despacho !== 0) {
        classDespacho = props.tiempos.EstadoDespacho;
    }

    if(props.tiempos.Factura && props.tiempos.Factura !== 0) {
        classFactura = props.tiempos.EstadoFactura;
    }

    if(props.tiempos.Ruta && props.tiempos.Ruta !== 0) {
        classRuta = props.tiempos.EstadoRuta;
    } 

    return (
        <div className="bar-progress">               
            <ul>
                <li>
                    <span className={classOrden}></span><p>Orden</p>
                    <p className="time">{props.tiempos.Orden !== 0 ? toDDHHMMSS(props.tiempos.Orden) : null}</p>
                    <i className={"step__line-inner " + classOrden}></i>
                </li>
                <li>
                    <span className={classDespacho}></span><p>Despacho</p>
                    <p className="time">{props.tiempos.Despacho !== 0 ? toDDHHMMSS(props.tiempos.Despacho) : null}</p>
                    <i className={"step__line-inner " + classDespacho}></i>
                </li>
                <li>
                    <span className={classFactura}></span><p>Factura</p>
                    <p className="time">{props.tiempos.Factura !== 0 ? toDDHHMMSS(props.tiempos.Factura) : null}</p>
                    <i className={"step__line-inner " + classFactura}></i>
                </li>
                <li>
                    <span className={classRuta}></span><p>Ruta</p>
                    <p className="time">{props.tiempos.Ruta !== 0 ? toDDHHMMSS(props.tiempos.Ruta) : null}</p>
                </li>
            </ul>
        </div>
    )
};

export default progressBar;